import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    // Form will be submitted to FormSubmit
    // Show success message after submission
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="contact-info-title">Contáctanos</h2>
            
            <div className="info-item">
              <div className="info-text">
                <h3>Ubicación</h3>
                <p>Calle de la Gerreria, 26, 1ºB,<br/>07002, Palma, Balearic Islands</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-text">
                <h3>Teléfono</h3>
                <p><a href="tel:+34871533824">+34 871 533 824</a></p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-text">
                <h3>Correo electrónico</h3>
                <p><a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></p>
              </div>
            </div>
          </div>

          <form 
            className="contact-form" 
            action="https://formsubmit.co/info@tabiagroup.com" 
            method="POST"
            onSubmit={handleSubmit}
          >
            {/* FormSubmit Configuration */}
            <input type="hidden" name="_subject" value="Nuevo mensaje desde la web de Tabia Group" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_next" value={window.location.href} />
            
            {isSubmitted && (
              <div className="success-message">
                ¡Gracias por tu mensaje! Nos pondremos en contacto contigo pronto.
              </div>
            )}
            
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Tu nombre"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Tu correo electrónico"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Número de teléfono"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Queremos ayudarte a…"
                value={formData.message}
                onChange={handleChange}
                rows="5"
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Enviar
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
